/********************************************************************
* ヘッダー背景色変更
**********************************************************************/
const headerChangeBg = () => {
    const header = document.querySelector('.js_header');

    const doWhenScroll = () => {
        // メニューが開いているときは処理をスキップ
        if (document.body.classList.contains('is_fixed')) return;
        
        const targetPos = 100;
        const scroll = window.scrollY;
        if (scroll > targetPos) {
            header.classList.add('is_bg');
        } else {
            header.classList.remove('is_bg');
        }
    }

    if (document.body.id === 'top') {
        window.addEventListener('scroll', doWhenScroll);
    } else {
        window.addEventListener('scroll', doWhenScroll);
    }
}

export default headerChangeBg;